import styled from 'styled-components'

export const NoResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => `${props.theme.spacing.sp64} ${props.theme.spacing.sp40}`};
`
